









import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import DiscountCategoryTable from '@accounting/components/tables/discount-category-table/discount-category-table.vue';

@Component({
  name: 'bpc-discount-categories',
  components: {
    'bpc-discount-category-table': DiscountCategoryTable,
  },
})
export default class DiscountCategories extends Vue {}
